import meetings from "./meetings";
import recruitmentApplications from "./recruitment-applications";
import resume from "./resume";
import employment from "./employment";

export default {
    employment,
    meetings,
    recruitmentApplications,
    resume,
};
